(() => {
  'use strict';
  if (window.__PN_NATIVE_COMMERCE__) return;
  window.__PN_NATIVE_COMMERCE__ = true;

  const initialize = () => {
    const config = window.PN_SHOPIFY || {};
    const products = (Array.isArray(config.products) ? config.products : []).filter((product) =>
      product &&
      Number.isSafeInteger(Number(product.id)) && Number(product.id) > 0 &&
      Number.isSafeInteger(Number(product.productId)) && Number(product.productId) > 0 &&
      ['number', 'string'].includes(typeof product.price) && String(product.price).trim() !== '' &&
      Number.isFinite(Number(product.price)) && Number(product.price) >= 0
    ).map((product) => ({ ...product, id: Number(product.id), productId: Number(product.productId), price: Number(product.price), available: product.available === true }));
    const rootValue = String(config.root || window.Shopify?.routes?.root || '/');
    const root = rootValue.startsWith('/') && !rootValue.startsWith('//') ? `${rootValue.replace(/\/+$/, '')}/` : '/';
    const route = (path) => `${root}${path}`;
    const normalizeGrind = (value) => String(value || '').toLowerCase().replace(/[^a-z]/g, '');
    const normalizeSize = (value) => {
      const grams = String(value || '').replace(/,/g, '').match(/(\d+)\s*g\b/i);
      return grams ? String(Number(grams[1])) : '';
    };
    const familyProducts = (form) => products.filter((product) => product.family === form.dataset.product);
    const selectedValue = (form, selector) => form.querySelector(`${selector}[aria-pressed="true"]`)?.dataset.value || '';
    const selectedProduct = (form) => familyProducts(form).find((product) =>
      normalizeGrind(product.grind) === normalizeGrind(selectedValue(form, '.grind-option')) &&
      normalizeSize(product.size) === normalizeSize(selectedValue(form, '.size-option'))
    );
    let currency = config.currency || 'USD';
    const money = (cents) => {
      const amount = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(amount);
      } catch (_) {
        return `${amount.toFixed(2)} ${currency}`;
      }
    };
    const createElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = String(text);
      return element;
    };
    const safeUrl = (value, sameOrigin = false) => {
      if (!value) return '';
      try {
        const url = new URL(String(value), location.origin);
        if (!['https:', 'http:'].includes(url.protocol) || (sameOrigin && url.origin !== location.origin)) return '';
        return url.href;
      } catch (_) { return ''; }
    };

    const matches = {
      light: { title: 'Light Roast', image: 'assets/light-roast.webp', alt: 'Piedra Negra Light Roast coffee', description: 'A bright, aromatic expression with lively citrus sweetness and a clean finish.', notesLabel: 'Notes:', notes: ' citrus, gentle sweetness', brew: ' pour-over, drip', href: '#coffee-light' },
      medium: { title: 'Medium Roast', image: 'assets/medium-roast.webp', alt: 'Piedra Negra Medium Roast coffee', description: 'Balanced chocolate and caramel notes with enough body for espresso and enough clarity for drip.', notesLabel: 'Notes:', notes: ' chocolate, caramel', brew: ' espresso, drip, French press', href: '#coffee-medium' },
      specialty: { title: 'Specialty Selection', image: 'assets/specialty.webp', alt: 'Piedra Negra Specialty Selection coffee', description: 'Our most selective expression—silky, layered and refined for a cup worth slowing down for.', notesLabel: 'Profile:', notes: ' sweet, silky, layered', brew: ' pour-over, French press', href: '#coffee-specialty' }
    };
    document.querySelectorAll('.taste-btn').forEach((button) => {
      button.addEventListener('click', () => {
        const match = matches[button.dataset.match];
        if (!match) return;
        document.querySelectorAll('.taste-btn').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        const image = document.getElementById('match-image');
        if (image) { image.src = config.assets?.[button.dataset.match] || match.image; image.alt = match.alt; }
        const title = document.getElementById('match-title');
        const description = document.getElementById('match-description');
        if (title) title.textContent = match.title;
        if (description) description.textContent = match.description;
        const notes = document.getElementById('match-notes');
        const brew = document.getElementById('match-brew');
        if (notes) notes.replaceChildren(createElement('strong', '', match.notesLabel), document.createTextNode(match.notes));
        if (brew) brew.replaceChildren(createElement('strong', '', 'Best for:'), document.createTextNode(match.brew));
        const link = document.getElementById('match-link');
        if (link) { link.href = match.href; link.textContent = `See ${match.title}`; }
      });
    });

    const pauseGalleryVideos = (gallery) => gallery.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const items = [...gallery.querySelectorAll('[data-gallery-item]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-index]')];
      const position = gallery.querySelector('[data-gallery-position]');
      let activeIndex = 0;
      const activateGalleryItem = (index) => {
        if (!items[index]) return;
        pauseGalleryVideos(gallery);
        activeIndex = index;
        items.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
        });
        thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(Number(thumb.dataset.galleryIndex) === index)));
        if (position) position.textContent = String(index + 1);
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => activateGalleryItem(Number(thumb.dataset.galleryIndex))));
      gallery.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || !event.target.closest('.gallery-thumb') || !items.length) return;
        event.preventDefault();
        const nextIndex = (activeIndex + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
        activateGalleryItem(nextIndex);
        thumbs.find((thumb) => Number(thumb.dataset.galleryIndex) === nextIndex)?.focus();
      });
      activateGalleryItem(0);
    });

    const menuButton = document.querySelector('.menu-toggle');
    const menuHeader = menuButton?.closest('header');
    const menuViewport = window.matchMedia('(max-width: 920px)');
    const updateMenuPosition = () => {
      if (menuHeader && menuViewport.matches) {
        menuHeader.style.setProperty('--pn-menu-top', `${Math.max(0, menuHeader.getBoundingClientRect().bottom)}px`);
      }
    };
    const closeMenu = () => {
      document.body.classList.remove('menu-open');
      menuButton?.setAttribute('aria-expanded', 'false');
      menuButton?.setAttribute('aria-label', 'Open menu');
    };
    menuButton?.addEventListener('click', () => {
      if (!menuViewport.matches) return;
      const open = document.body.classList.toggle('menu-open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      updateMenuPosition();
    });
    document.querySelectorAll('.nav-links a').forEach((link) => link.addEventListener('click', closeMenu));
    menuViewport.addEventListener('change', () => { closeMenu(); updateMenuPosition(); });
    window.addEventListener('resize', updateMenuPosition, { passive: true });
    window.addEventListener('scroll', updateMenuPosition, { passive: true });
    window.visualViewport?.addEventListener('resize', updateMenuPosition, { passive: true });
    window.addEventListener('pagehide', closeMenu);
    window.addEventListener('pageshow', closeMenu);
    window.addEventListener('popstate', closeMenu);
    window.addEventListener('hashchange', closeMenu);
    if ('ResizeObserver' in window && menuHeader) new ResizeObserver(updateMenuPosition).observe(menuHeader);
    updateMenuPosition();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
      }), { threshold: .12 });
      document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
    } else {
      document.querySelectorAll('.reveal').forEach((element) => element.classList.add('visible'));
    }

    const cartLayer = document.querySelector('.cart-layer');
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartItems = document.querySelector('.cart-items');
    const cartEmpty = document.querySelector('.cart-empty');
    const cartSubtotal = document.querySelector('.cart-subtotal');
    const checkoutOpen = document.querySelector('.checkout-open');
    const toast = document.querySelector('.cart-toast');
    const forms = [...document.querySelectorAll('.purchase-form')];
    let cart = null;
    let cartVerified = false;
    let busy = false;
    let cartVersion = 0;
    let activeRead = null;
    let toastTimer;
    let cartReturnFocus = null;
    let detailReturnFocus = null;
    let activeDetail = null;
    let modalScrollStyle = null;
    const cartError = createElement('div', 'cart-error');
    cartError.setAttribute('role', 'status');
    cartError.setAttribute('aria-live', 'polite');
    cartError.style.cssText = 'padding:12px 0;font-size:.9rem;';
    cartError.hidden = true;
    (document.querySelector('.cart-body') || cartDrawer)?.prepend(cartError);
    document.querySelectorAll('.checkout-view').forEach((element) => element.remove());
    if (checkoutOpen) checkoutOpen.textContent = 'Secure checkout';
    if (cartDrawer && !cartDrawer.hasAttribute('tabindex')) cartDrawer.tabIndex = -1;

    const focusable = (container) => [...container.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),video[controls],[tabindex]:not([tabindex="-1"])')].filter((element) => !element.closest('[hidden],[inert]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
    const focusFirst = (container) => {
      if (!container) return;
      if (!container.hasAttribute('tabindex')) container.tabIndex = -1;
      (focusable(container)[0] || container).focus({ preventScroll: true });
    };
    const restoreFocus = (element) => {
      if (element?.isConnected && element.getClientRects().length) element.focus({ preventScroll: true });
    };
    const syncScrollLock = () => {
      const locked = document.body.classList.contains('cart-visible') || Boolean(activeDetail);
      if (locked && modalScrollStyle === null) {
        modalScrollStyle = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else if (!locked && modalScrollStyle !== null) {
        document.body.style.overflow = modalScrollStyle;
        modalScrollStyle = null;
      }
    };
    const syncDetail = () => {
      const previous = activeDetail;
      activeDetail = [...document.querySelectorAll('.coffee-detail')].find((detail) => `#${detail.id}` === location.hash && !detail.classList.contains('product-page') && !detail.classList.contains('pn-product-page')) || null;
      document.querySelectorAll('.coffee-detail').forEach((detail) => {
        if (detail !== activeDetail) pauseGalleryVideos(detail);
      });
      if (activeDetail !== previous && activeDetail && !document.body.classList.contains('cart-visible')) {
        if (!detailReturnFocus) detailReturnFocus = document.activeElement;
        requestAnimationFrame(() => { if (activeDetail && !document.body.classList.contains('cart-visible')) focusFirst(activeDetail); });
      } else if (!activeDetail && previous && !document.body.classList.contains('cart-visible')) {
        restoreFocus(detailReturnFocus);
        detailReturnFocus = null;
      }
      syncScrollLock();
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      let url;
      try { url = new URL(link.href, location.href); } catch (_) { return; }
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash.startsWith('#coffee-')) detailReturnFocus = link;
    });
    window.addEventListener('hashchange', syncDetail);
    document.querySelectorAll('.detail-close, .detail-back').forEach((link) => link.addEventListener('click', () => {
      const detail = link.closest('.coffee-detail');
      if (detail) pauseGalleryVideos(detail);
    }));

    const showCartError = (message) => {
      cartError.replaceChildren(createElement('p', '', message));
      const fallback = createElement('a', '', 'View your bag');
      fallback.href = route('cart');
      const retry = createElement('button', '', 'Try again');
      retry.type = 'button';
      retry.style.cssText = 'margin-left:16px;text-decoration:underline;cursor:pointer;';
      retry.addEventListener('click', () => { if (!busy) refreshCart().catch(() => {}); });
      cartError.append(fallback, retry);
      cartError.hidden = false;
    };
    const request = async (path, body) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(route(path), {
          method: body === undefined ? 'GET' : 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
          ...(body === undefined ? {} : { body: JSON.stringify(body) }),
          signal: controller.signal
        });
        let data;
        try { data = await response.json(); } catch (_) { throw new Error('The store returned an unexpected response. Please try again.'); }
        if (!response.ok || (Number(data.status) >= 400)) {
          const detail = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Your bag could not be updated. Please try again.';
          throw new Error(detail);
        }
        return data;
      } catch (error) {
        if (error.name === 'AbortError') throw new Error('The store took too long to respond. Check your bag before trying again.');
        if (error instanceof TypeError) throw new Error('We could not connect to the store. Check your connection and try again.');
        throw error;
      } finally { clearTimeout(timeout); }
    };

    const renderCart = () => {
      if (!cart) {
        if (checkoutOpen) checkoutOpen.disabled = true;
        if (cartEmpty) cartEmpty.style.display = 'none';
        if (cartItems) cartItems.style.display = 'none';
        return;
      }
      if (cart.currency) currency = cart.currency;
      const items = Array.isArray(cart.items) ? cart.items : [];
      document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = String(cart.item_count || 0); });
      if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
      if (checkoutOpen) { checkoutOpen.disabled = busy || !cartVerified || !items.length; checkoutOpen.setAttribute('aria-disabled', String(checkoutOpen.disabled)); }
      if (cartEmpty) cartEmpty.style.display = items.length ? 'none' : 'grid';
      if (!cartItems) return;
      const previousControl = cartItems.contains(document.activeElement) ? document.activeElement : null;
      const previousKey = previousControl?.dataset.key;
      const previousAction = previousControl?.dataset.cartAction;
      cartItems.style.display = items.length ? 'grid' : 'none';
      const fragment = document.createDocumentFragment();
      items.forEach((item) => {
        const product = products.find((product) => String(product.id) === String(item.variant_id));
        const name = product?.title || item.product_title || item.title || 'Coffee';
        const article = createElement('article', 'cart-item');
        const imageWrapper = createElement('div', 'cart-item-image');
        const imageUrl = safeUrl(item.featured_image?.url || item.image || product?.image);
        if (imageUrl) {
          const image = createElement('img');
          image.src = imageUrl;
          image.alt = name;
          image.loading = 'lazy';
          imageWrapper.append(image);
        }
        const content = createElement('div');
        const top = createElement('div', 'cart-item-top');
        top.append(createElement('span', 'cart-item-name', name), createElement('span', 'cart-item-price', money(item.final_line_price ?? item.line_price)));
        const optionText = product ? `${product.grind} · ${product.size}` : item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const variant = createElement('div', 'cart-item-variant', optionText);
        const bottom = createElement('div', 'cart-item-bottom');
        const quantity = createElement('div', 'mini-quantity');
        quantity.setAttribute('aria-label', `Quantity for ${name}`);
        const button = (action, label, text, className = '') => {
          const control = createElement('button', className, text);
          control.type = 'button';
          control.dataset.cartAction = action;
          control.dataset.key = item.key;
          control.setAttribute('aria-label', label);
          control.disabled = busy || !cartVerified;
          return control;
        };
        quantity.append(button('minus', `Decrease quantity of ${name}`, '−'), createElement('span', '', item.quantity), button('plus', `Increase quantity of ${name}`, '+'));
        bottom.append(quantity, button('remove', `Remove ${name}`, 'Remove', 'cart-remove'));
        content.append(top, variant, bottom);
        article.append(imageWrapper, content);
        fragment.append(article);
      });
      cartItems.replaceChildren(fragment);
      if (previousKey && !busy) {
        const replacement = [...cartItems.querySelectorAll('[data-cart-action]')].find((control) => control.dataset.key === previousKey && control.dataset.cartAction === previousAction);
        (replacement || cartDrawer?.querySelector('.cart-close'))?.focus({ preventScroll: true });
      }
    };
    const refreshCart = ({ force = false } = {}) => {
      if (activeRead && !force) return activeRead;
      const version = ++cartVersion;
      const task = (async () => {
        try {
          const data = await request('cart.js');
          if (!Array.isArray(data.items) || typeof data.item_count !== 'number') throw new Error('Your bag could not be loaded. Please try again.');
          if (version === cartVersion) {
            cart = data;
            cartVerified = true;
            cartError.hidden = true;
            renderCart();
          }
          return data;
        } catch (error) {
          if (version === cartVersion) {
            cartVerified = false;
            showCartError(error.message || 'Your bag could not be loaded. Please try again.');
            renderCart();
          }
          throw error;
        } finally { if (activeRead === task) activeRead = null; }
      })();
      activeRead = task;
      return task;
    };

    const setFormError = (form, message) => {
      let error = form.querySelector('.purchase-error, .pn-status');
      if (!error) {
        error = createElement('p', 'purchase-error');
        error.setAttribute('role', 'status');
        error.setAttribute('aria-live', 'polite');
        error.style.cssText = 'margin:12px 0 0;font-size:.85rem;';
        form.append(error);
      }
      error.textContent = message;
      error.hidden = !message;
    };
    const updateForm = (form) => {
      const family = familyProducts(form);
      const grind = normalizeGrind(selectedValue(form, '.grind-option'));
      const size = normalizeSize(selectedValue(form, '.size-option'));
      form.querySelectorAll('.grind-option').forEach((button) => {
        const exists = family.some((product) => normalizeGrind(product.grind) === normalizeGrind(button.dataset.value) && normalizeSize(product.size) === size);
        button.disabled = busy || !exists;
        button.setAttribute('aria-disabled', String(button.disabled));
      });
      form.querySelectorAll('.size-option').forEach((button) => {
        const product = family.find((product) => normalizeGrind(product.grind) === grind && normalizeSize(product.size) === normalizeSize(button.dataset.value));
        button.disabled = busy || !product;
        button.setAttribute('aria-disabled', String(button.disabled));
        const small = button.querySelector('small');
        if (small) {
          if (!product) small.textContent = 'Not available';
          else {
            const ounces = normalizeSize(button.dataset.value) === '1000' ? '35.27 oz' : '12 oz';
            small.textContent = `${money(product.price)} · ${ounces}`;
          }
        }
      });
      const grindLabel = form.querySelector('.selected-grind');
      const sizeLabel = form.querySelector('.selected-size');
      if (grindLabel) grindLabel.textContent = selectedValue(form, '.grind-option');
      if (sizeLabel) sizeLabel.textContent = selectedValue(form, '.size-option');
      const product = selectedProduct(form);
      const price = form.querySelector('.purchase-price strong');
      if (price) price.textContent = product ? money(product.price) : 'Unavailable';
      const add = form.querySelector('.add-to-cart');
      if (add) {
        add.disabled = busy || !product?.available;
        add.setAttribute('aria-disabled', String(add.disabled));
        add.textContent = form.dataset.adding === 'true' ? 'Adding…' : !product ? 'Unavailable' : !product.available ? 'Sold out' : 'Add to bag';
      }
      form.querySelectorAll('[data-qty]').forEach((button) => { button.disabled = busy || !product?.available; });
      const productLink = form.querySelector('.pn-product-link');
      if (productLink) {
        const url = safeUrl(product?.url, true);
        if (url) { productLink.href = url; productLink.hidden = false; }
        else { productLink.removeAttribute('href'); productLink.hidden = true; }
      }
      const hiddenId = form.querySelector('input[name="id"]');
      if (hiddenId) { hiddenId.value = product?.id || ''; hiddenId.disabled = !product; }
    };
    const setBusy = (value) => {
      busy = value;
      cartDrawer?.setAttribute('aria-busy', String(value));
      forms.forEach(updateForm);
      renderCart();
    };
    const openCart = ({ refresh = true } = {}) => {
      if (!cartLayer || !cartDrawer) { location.assign(route('cart')); return; }
      if (!document.body.classList.contains('cart-visible')) cartReturnFocus = activeDetail ? detailReturnFocus || document.querySelector('.cart-open-button') : document.activeElement;
      document.body.classList.add('cart-visible');
      cartLayer.setAttribute('aria-hidden', 'false');
      if (activeDetail) {
        history.replaceState(null, '', location.pathname + location.search);
        syncDetail();
        detailReturnFocus = null;
      }
      closeMenu();
      syncScrollLock();
      requestAnimationFrame(() => { if (document.body.classList.contains('cart-visible')) focusFirst(cartDrawer); });
      if (refresh && !busy) refreshCart().catch(() => {});
    };
    const closeCart = () => {
      if (!document.body.classList.contains('cart-visible')) return;
      document.body.classList.remove('cart-visible');
      cartLayer?.setAttribute('aria-hidden', 'true');
      syncScrollLock();
      restoreFocus(cartReturnFocus);
      cartReturnFocus = null;
    };
    const flashAdded = () => {
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.classList.add('visible');
      toastTimer = setTimeout(() => toast.classList.remove('visible'), 1400);
    };

    forms.forEach((form) => {
      const current = familyProducts(form).find((product) => String(product.productId) === String(config.currentProductId));
      if (current) {
        form.querySelectorAll('.grind-option').forEach((button) => button.setAttribute('aria-pressed', String(normalizeGrind(button.dataset.value) === normalizeGrind(current.grind))));
        form.querySelectorAll('.size-option').forEach((button) => button.setAttribute('aria-pressed', String(normalizeSize(button.dataset.value) === normalizeSize(current.size))));
      }
      const quantity = form.querySelector('.qty-value');
      ['.grind-option', '.size-option'].forEach((selector) => form.querySelectorAll(selector).forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled || busy) return;
          form.querySelectorAll(selector).forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          setFormError(form, '');
          updateForm(form);
        });
      }));
      form.querySelectorAll('[data-qty]').forEach((button) => button.addEventListener('click', () => {
        if (!quantity || button.disabled || busy) return;
        const value = Math.max(1, Number(quantity.textContent) || 1);
        quantity.textContent = String(button.dataset.qty === 'plus' ? Math.min(12, value + 1) : Math.max(1, value - 1));
      }));
      const addToCart = async (event) => {
        event.preventDefault();
        if (busy) return;
        const product = selectedProduct(form);
        if (!product?.available) { updateForm(form); setFormError(form, product ? 'This coffee is currently sold out.' : 'This combination is not available.'); return; }
        const amount = Math.max(1, Math.min(12, parseInt(quantity?.textContent || '1', 10) || 1));
        setFormError(form, '');
        form.dataset.adding = 'true';
        cartVersion += 1;
        activeRead = null;
        setBusy(true);
        let added = false;
        try {
          await request('cart/add.js', { items: [{ id: product.id, quantity: amount }] });
          added = true;
          if (quantity) quantity.textContent = '1';
          await refreshCart({ force: true });
          flashAdded();
          openCart({ refresh: false });
        } catch (error) {
          if (added) {
            showCartError('Your coffee was added, but the bag could not refresh. View your bag before adding it again.');
            openCart({ refresh: false });
          } else {
            setFormError(form, error.message || 'Your coffee could not be added. Please try again.');
            await refreshCart({ force: true }).catch(() => {});
          }
        } finally {
          delete form.dataset.adding;
          setBusy(false);
        }
      };
      form.querySelector('.add-to-cart')?.addEventListener('click', addToCart);
      if (form.tagName === 'FORM') form.addEventListener('submit', addToCart);
      updateForm(form);
    });

    cartItems?.addEventListener('click', async (event) => {
      const control = event.target.closest('[data-cart-action]');
      if (!control || busy || !cartVerified || !cart) return;
      const item = cart.items.find((entry) => entry.key === control.dataset.key);
      if (!item) return;
      const action = control.dataset.cartAction;
      if (!['minus', 'plus', 'remove'].includes(action)) return;
      const amount = action === 'remove' ? 0 : Math.max(0, item.quantity + (action === 'plus' ? 1 : -1));
      cartVersion += 1;
      activeRead = null;
      setBusy(true);
      cartError.hidden = true;
      try {
        const data = await request('cart/change.js', { id: item.key, quantity: amount });
        if (!Array.isArray(data.items)) throw new Error('Your bag changed, but could not refresh. Please check your bag.');
        cart = data;
        cartVerified = true;
      } catch (error) {
        await refreshCart({ force: true }).catch(() => {});
        showCartError(error.message || 'Your bag could not be updated. Please try again.');
      } finally {
        setBusy(false);
        const next = [...(cartItems?.querySelectorAll('[data-cart-action]') || [])].find((button) => button.dataset.key === item.key && button.dataset.cartAction === action);
        (next || cartDrawer?.querySelector('.cart-close'))?.focus({ preventScroll: true });
      }
    });
    document.querySelectorAll('.cart-open-button').forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); openCart(); }));
    document.querySelectorAll('.cart-close-trigger').forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); closeCart(); }));
    checkoutOpen?.addEventListener('click', (event) => {
      event.preventDefault();
      if (!busy && cartVerified && cart?.item_count > 0) location.assign(route('checkout'));
    });
    document.addEventListener('keydown', (event) => {
      const container = document.body.classList.contains('cart-visible') ? cartDrawer : activeDetail || (document.body.classList.contains('menu-open') ? menuHeader : null);
      if (event.key === 'Escape') {
        if (document.body.classList.contains('cart-visible')) { event.preventDefault(); closeCart(); }
        else if (activeDetail) {
          event.preventDefault();
          history.replaceState(null, '', `${location.pathname}${location.search}#collection`);
          syncDetail();
        } else if (document.body.classList.contains('menu-open')) { closeMenu(); menuButton?.focus(); }
      }
      if (event.key !== 'Tab' || !container) return;
      const items = focusable(container);
      if (!items.length) { event.preventDefault(); container.focus(); return; }
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    window.addEventListener('pageshow', (event) => { if (event.persisted && !busy) refreshCart().catch(() => {}); });
    syncDetail();
    renderCart();
    refreshCart().catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
